import { peptide } from './initial/flow';

const PeptideFlows = {
  peptide
};

export default PeptideFlows;
